import { SmartAssistantImportValidationError } from '@iota/inh-core-v1-management-client';

export const SMART_ASSISTANT_VALIDATION_ERROR_LABELS: Record<SmartAssistantImportValidationError, string> = {
    EMPLOYEE_NOT_FOUND: $localize`Employee not found`,
    DUPLICATE_ENTRY: $localize`Duplicate entry in file`,
    NO_ACTIVE_SUBSCRIPTION_OF_SOLUTION_PARTNER: $localize`No active subscription found for solution partner`,
    MULTIPLE_ACTIVE_SUBSCRIPTIONS_OF_SOLUTION_PARTNER: $localize`Multiple active subscriptions found for solution partner`,
    NO_ACTIVE_SUBSCRIPTION_OF_PRODUCT: $localize`No active subscription found for the selected product`,
    MULTIPLE_ACTIVE_SUBSCRIPTIONS_OF_PRODUCT: $localize`Multiple active subscriptions found for the selected product`,
    EMPTY_SOLUTION_PARTNER_IDENTIFICATION_NUMBER: $localize`Solution partner identification number is empty`,
    NO_URBAN_SPORTS_CLUB_SUBSCRIPTION_FOR_MONTH: $localize`No Urban Sports Club subscription found for given month`,
    NO_URBAN_SPORTS_CLUB_PRODUCT_CONFIGURED: $localize`No Urban Sports Club product configured`,
    PRICING_OPTION_INTERNAL_KEY_MISMATCH: $localize`Pricing option internal key mismatch`,
    INCOMPLETE_PRICING_CONFIGURATION: $localize`Incomplete pricing configuration`,
    INITIAL_PRICING_OPTION_NOT_FOUND: $localize`Initial pricing option not found`,
    NO_SUBSCRIPTION_BUDGET_OPTION: $localize`No subscription budget option found`,
    MISSING_REQUIRED_VALUE: $localize`Required value is missing`,
    AMBIGUOUS_EMPLOYEE_NUMBER: $localize`Employee no. is ambiguous`,
    REGISTERED_EMPLOYEE_NOT_EDITABLE: $localize`Registered employee cannot be edited`,
    INVALID_NUMBER: $localize`Invalid number`,
    NEGATIVE_NUMBER: $localize`Number must not be negative`,
    EMPLOYEE_ALREADY_REGISTERED: $localize`Employee is already registered`,
    EMPLOYEE_GROUP_NOT_FOUND: $localize`Employee group not found`,
    INVALID_DATE: $localize`Invalid date`,
    AMBIGUOUS_DATE_FORMAT: $localize`Date format is ambiguous`,
    EMPLOYEE_NOT_REGISTERED: $localize`Employee is not registered`,
    CURRENT_EMPLOYEE_GROUP_NOT_CHANGEABLE: $localize`Current employee group cannot be changed`,
    TARGET_EMPLOYEE_GROUP_NOT_CHANGEABLE: $localize`Target employee group cannot be assigned`,
    GROUP_CHANGE_DATE_TOO_EARLY: $localize`Group change date is too early`,
    GROUP_CHANGE_DATE_NOT_FIRST_OF_MONTH: $localize`Group change date must be the first of a month`,
    SCHEDULED_EMPLOYEE_GROUP_CHANGE_NOT_MODIFIABLE: $localize`Scheduled employee group change cannot be modified`,
    OFFICE_NOT_FOUND: $localize`Office not found`,
    OFFICE_DEACTIVATED: $localize`Office is deactivated`,
    AMBIGUOUS_OFFICE_NAME: $localize`Office name is ambiguous`,
    ALTERNATIVE_EMPLOYEE_NUMBER_IN_USE: $localize`Employee number is already in use`,
    LEAVING_DATE_REMOVAL_NOT_ALLOWED: $localize`Leaving date cannot be removed`,
    LEAVING_DATE_MODIFICATION_DEADLINE_PASSED: $localize`Leaving date can no longer be modified`,
    EMPLOYEE_ALREADY_EXISTS: $localize`Employee already exists`,
    DATE_OF_BIRTH_NOT_IN_PAST: $localize`Date of birth is not in the past`,
    INVALID_EMPLOYEE_NUMBER: $localize`Invalid employee number`
};
